export default __webpack_public_path__ + "static/media/travily-3.c2cb6f66.PNG";